import Misspelling from "app/ui/Misspelling";

const POSSIBLE_TYPOS: { [key: string]: Array<string> } = {
  attempts: ["atempts", "attemps"],
  begin: ["beegin"],
  chance: ["chanse"],
  correct: ["corect"],
  correctly: ["corectly"],
  daily: ["daley", "dailey"],
  decrease: ["decreese"],
  definition: ["defanition", "definishin"],
  earlier: ["earliar", "erlier"],
  expand: ["expend"],
  guess: ["gess"],
  hear: ["here"],
  individual: ["indavidual", "indiviule"],
  instead: ["insted"],
  instructions: ["instructsions"],
  multiply: ["multaply"],
  next: ["nekst"],
  play: ["pley"],
  possible: ["possibel", "posible"],
  really: ["realy", "rilly"],
  refresh: ["reffresh"],
  results: ["ressults"],
  slightly: ["slitely"],
  spell: ["spel"],
  spelling: ["speling"],
  stuck: ["stuk"],
  supposed: ["suposed"],
  video: ["vidio"],
  vocabulary: ["vocabulry"],
  words: ["werdz"],
  "you'll": ["you'l"],
  your: ["you're"],
  "you're": ["your"],
};

interface TypoWordProps {
  word: string;
  typoChance?: number;
}

export default function TypoWord({ word, typoChance = 0.05 }: TypoWordProps) {
  if (!(word.toLocaleLowerCase() in POSSIBLE_TYPOS)) {
    console.warn(`No typos defined for ${word}`);
  }

  const isTypo =
    word.toLocaleLowerCase() in POSSIBLE_TYPOS && Math.random() < typoChance;

  if (isTypo) {
    const possibleTypos = POSSIBLE_TYPOS[word.toLocaleLowerCase()];
    const typo =
      possibleTypos[Math.floor(Math.random() * possibleTypos.length)];
    word = applyUppercase(word, typo);
  }

  return (
    <>{isTypo ? <Misspelling>{word}</Misspelling> : <span>{word}</span>}</>
  );
}

function applyUppercase(originalWord: string, typo: string): string {
  const isCapitalized =
    originalWord.length > 0 &&
    originalWord[0] === originalWord[0].toUpperCase();
  return isCapitalized ? typo.charAt(0).toUpperCase() + typo.slice(1) : typo;
}
